import React from "react";
import "./client.css";
import RepairSVG from '../../utils/assets/client/troubleshooting.svg'
import NextSVG from '../../utils/assets/next.svg'

import { Link } from "react-router-dom";

const Cards = ({ CardData }) => {
  return (
    <>
    <div className="pointer shadowCustom p-4  w-100">
        <div>
          <img src={CardData.image} width={35} alt="ReapirSVG" />
        </div>
        <div className="f-32">
              <p className="py-2 m-0">{CardData.title}</p>
              <div style={{minHeight: "120px"}}>
              {
                CardData.actions && CardData.actions.map((item) => {
                  return (
                    <div className="card_Desc ul_m">{item.actionTitle} : {item.actionNum}</div>
                  )
                })
              }
              </div>
        </div>
        <Link to={CardData.allLink} className="w-100 bg-black text-white p_12 mt-2 d-flex justify-content-center align-items-center text-dec-none rounded"> <span className="m_r ">View All</span> <img src={NextSVG} width={18} alt="next" /></Link>
    </div>
    </>
    
  );
};

export default Cards;
